export { default } from './SocialsList';
